import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "flex items-center justify-between mb-8 max-w-3xl bg-green-500 rounded"
};
var _hoisted_2 = {
  "class": "flex items-center"
};
var _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  "class": "flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, [/*#__PURE__*/_createElementVNode("polygon", {
  points: "0 11 2 9 7 14 18 3 20 5 7 18"
})], -1);
var _hoisted_4 = {
  "class": "py-4 text-white text-sm font-medium"
};
var _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  "class": "block w-2 h-2 fill-green-800 group-hover:fill-white",
  xmlns: "http://www.w3.org/2000/svg",
  width: "235.908",
  height: "235.908",
  viewBox: "278.046 126.846 235.908 235.908"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z"
})], -1);
var _hoisted_6 = [_hoisted_5];
var _hoisted_7 = {
  key: 1,
  "class": "flex items-center justify-between mb-8 max-w-3xl bg-red-500 rounded"
};
var _hoisted_8 = {
  "class": "flex items-center"
};
var _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  "class": "flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z"
})], -1);
var _hoisted_10 = {
  key: 0,
  "class": "py-4 text-white text-sm font-medium"
};
var _hoisted_11 = {
  key: 1,
  "class": "py-4 text-white text-sm font-medium"
};
var _hoisted_12 = {
  key: 0
};
var _hoisted_13 = {
  key: 1
};
var _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  "class": "block w-2 h-2 fill-red-800 group-hover:fill-white",
  xmlns: "http://www.w3.org/2000/svg",
  width: "235.908",
  height: "235.908",
  viewBox: "278.046 126.846 235.908 235.908"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z"
})], -1);
var _hoisted_15 = [_hoisted_14];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_ctx.$page.props.flash.success && $data.show ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$page.props.flash.success), 1)]), _createElementVNode("button", {
    type: "button",
    "class": "group mr-2 p-2",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $data.show = false;
    })
  }, _hoisted_6)])) : _createCommentVNode("", true), (_ctx.$page.props.flash.error || Object.keys(_ctx.$page.props.errors).length > 0) && $data.show ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _ctx.$page.props.flash.error ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$page.props.flash.error), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_11, [Object.keys(_ctx.$page.props.errors).length === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_12, "There is one form error.")) : (_openBlock(), _createElementBlock("span", _hoisted_13, "There are " + _toDisplayString(Object.keys(_ctx.$page.props.errors).length) + " form errors.", 1))]))]), _createElementVNode("button", {
    type: "button",
    "class": "group mr-2 p-2",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $data.show = false;
    })
  }, _hoisted_15)])) : _createCommentVNode("", true)]);
}